import { fromJS } from 'immutable';
import actionTypes from 'constants/checkoutWizardConstants';

export const initialState = fromJS({
  currentStep: 1,
});

const checkoutWizardReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.GO_TO_NEXT_STEP:
      return state.set('currentStep', state.get('currentStep') + 1);
    case actionTypes.GO_TO_PREVIOUS_STEP:
      return state.set('currentStep', state.get('currentStep') - 1);
    case actionTypes.GO_TO_STEP:
      return state.set('currentStep', action.payload);
    default:
      return state;
  }
};

export default checkoutWizardReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/checkoutWizardReducer.js